(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-drawer-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__dmMnav) return;
    window.__dmMnav = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dm-toggle]');
      if (!btn) return;
      var item = btn.closest('[data-dm-acc]');
      var nav = btn.closest('[data-dm-mnav]');
      if (!item || !nav) return;
      e.preventDefault();
      var willOpen = !item.classList.contains('is-open');
      nav.querySelectorAll('[data-dm-acc].is-open').forEach(function (el) {
        if (el === item) return;
        el.classList.remove('is-open');
        el.querySelectorAll('[data-dm-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      });
      item.classList.toggle('is-open', willOpen);
      item.querySelectorAll('[data-dm-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', willOpen ? 'true' : 'false'); });
    });

    /* Fermeture douce : le thème retirait le menu au bout de 125 ms, avant la fin de l'animation. */
    var DM_CLOSE_MS = 360;
    customElements.whenDefined('header-component').then(function () {
      var C = customElements.get('header-component');
      if (!C || C.prototype.__dmSmooth) return;
      C.prototype.__dmSmooth = true;
      var origOpen = C.prototype.openMobileMenu;
      C.prototype.openMobileMenu = function () {
        var o = this.mobileMenuOverlay;
        if (o && o.__dmTimer) { clearTimeout(o.__dmTimer); o.__dmTimer = null; }
        return origOpen.apply(this, arguments);
      };
      C.prototype.closeMobileMenu = function () {
        var o = this.mobileMenuOverlay;
        var self = this;
        if (!o || !o.classList.contains('is-open') || o.classList.contains('is-closing')) return;
        o.classList.add('is-closing');
        o.__dmTimer = setTimeout(function () {
          o.__dmTimer = null;
          o.classList.remove('is-open', 'is-closing');
          document.body.classList.remove('overflow-hidden');
          if (self.menuToggle) self.menuToggle.focus({ preventScroll: true });
        }, DM_CLOSE_MS);
      };
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordions"] && !Shopify.designMode) return;
  try {
    /* --- Personnalisation : un seul accordeon ouvert a la fois, par groupe ---
     L'evenement `toggle` ne remonte pas dans le DOM : on l'ecoute donc en phase
     de capture sur le document. Ecouter sur document couvre aussi les
     accordeons injectes dynamiquement, comme ceux des onglets de la page
     d'accueil que tabs.js reconstruit a chaque clic. */
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;

      const group = details.closest('.accordions');
      if (!group) return;

      group.querySelectorAll('details[open]').forEach((other) => {
        if (other !== details && other.closest('.accordions') === group) {
          other.open = false;
        }
      });
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dm-bestsellers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dm-bestsellers')) {
    customElements.define(
      'dm-bestsellers',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.dm-bsl__track');
          this.dots = this.querySelector('.dm-bsl__dots');
          this.prev = this.querySelector('.dm-bsl__arrow--prev');
          this.next = this.querySelector('.dm-bsl__arrow--next');
          if (!this.track) return;

          this.prev.addEventListener('click', () => this.go(-1));
          this.next.addEventListener('click', () => this.go(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.dots.addEventListener('click', (e) => {
            const dot = e.target.closest('button');
            if (dot) this.scrollToPage(Number(dot.dataset.page));
          });
          this.addEventListener('click', (e) => {
            const btn = e.target.closest('button.dm-bsl__add');
            if (btn) this.add(e, btn);
          });

          this.resizeObserver = new ResizeObserver(() => this.build());
          this.resizeObserver.observe(this.track);
          this.build();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        metrics() {
          const item = this.track.querySelector('.dm-bsl__item');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
          const perView = Math.max(1, Math.floor((this.track.clientWidth + gap + 2) / step));
          const max = this.track.scrollWidth - this.track.clientWidth;
          const pageWidth = step * perView;
          const pages = max > 2 ? Math.ceil((max - 2) / pageWidth) + 1 : 1;
          return { step, perView, max, pageWidth, pages };
        }

        build() {
          const { pages } = this.metrics();
          if (this.dots.childElementCount !== pages) {
            this.dots.innerHTML = '';
            for (let i = 0; i < pages; i++) {
              const b = document.createElement('button');
              b.type = 'button';
              b.dataset.page = i;
              b.tabIndex = -1;
              this.dots.appendChild(b);
            }
          }
          this.classList.toggle('dm-bsl--static', pages <= 1);
          this.update();
        }

        update() {
          const { max, pageWidth, pages } = this.metrics();
          const left = this.track.scrollLeft;
          let page = left >= max - 2 ? pages - 1 : Math.round(left / pageWidth);
          page = Math.min(Math.max(page, 0), pages - 1);
          [...this.dots.children].forEach((d, i) => d.classList.toggle('is-active', i === page));
          this.prev.disabled = left <= 2;
          this.next.disabled = left >= max - 2;
        }

        go(dir) {
          const { pageWidth } = this.metrics();
          this.track.scrollBy({ left: dir * pageWidth, behavior: 'smooth' });
        }

        scrollToPage(i) {
          const { pageWidth, max } = this.metrics();
          this.track.scrollTo({ left: Math.min(i * pageWidth, max), behavior: 'smooth' });
        }

        async add(event, btn) {
          event.preventDefault();
          if (btn.disabled || btn.classList.contains('is-loading')) return;
          btn.classList.add('is-loading');
          const items = [{ id: Number(btn.dataset.variantId), quantity: 1 }];
          const sections = ['auto-gifts'];
          const drawer = document.querySelector('cart-drawer');
          if (drawer?.dataset.sectionId) sections.push(drawer.dataset.sectionId);
          try {
            const url = window.Theme?.routes?.cart_add_url || '/cart/add.js';
            const res = await fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items, sections: sections.join(','), sections_url: window.location.pathname }),
            });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || 'add failed');
            if (window.location.pathname.includes('/cart')) {
              window.location.reload();
              return;
            }
            const cartIcon = document.querySelector('cart-icon');

            /* Met à jour le panier latéral directement (sans passer par un import qui pouvait échouer
               et renvoyer vers la page /cart), puis l'ouvre. */
            if (drawer && typeof drawer.renderCartContents === 'function' && data.sections?.[drawer.dataset.sectionId]) {
              await drawer.renderCartContents({ sections: data.sections });
              if (cartIcon?.addToCartBehavior === 'notification') {
                document.dispatchEvent(
                  new CustomEvent('toast:open', {
                    detail: { type: 'success', message: window.Theme?.translations?.addToCartNotificationMessage },
                  })
                );
              } else {
                drawer.open();
              }
            } else {
              window.location.href = window.Theme?.routes?.cart_url || '/cart';
              return;
            }
            btn.classList.add('is-added');
            setTimeout(() => btn.classList.remove('is-added'), 1200);
          } catch (err) {
            console.error(err);
          } finally {
            btn.classList.remove('is-loading');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dm-box-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dm-box-selector')) {
    customElements.define(
      'dm-box-selector',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const tile = event.target.closest('.dm-boxsel__tile');
            if (tile && this.contains(tile)) {
              this.select(tile.dataset.box, tile);
              return;
            }

            const card = event.target.closest('.dm-boxsel__card');
            if (!card || !this.contains(card)) return;
            if (event.target.closest('a, button')) return;

            if (card.classList.contains('is-reco')) {
              const link = card.querySelector('a.dm-boxsel__btn');
              if (link) window.location.href = link.href;
              return;
            }

            const box = card.dataset.box;
            const match = this.querySelector(`.dm-boxsel__tile[data-box="${box}"]`);
            this.select(box, match);
          });
        }

        select(box, activeTile) {
          this.querySelectorAll('.dm-boxsel__tile').forEach((t) => {
            const active = t === activeTile;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          const target = Number(box);
          const prev = Number(this.dataset.reco) || 0;
          if (prev === target) return;
          const dir = target > prev ? 1 : -1;
          this.dataset.reco = box;

          const mobile = window.matchMedia('(max-width: 749px)').matches;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (mobile && !reduced) {
            const incoming = this.querySelector(`.dm-boxsel__card[data-box="${box}"]`);
            if (incoming) {
              this.style.setProperty('--dm-dir', dir);
              incoming.style.transition = 'none';
              incoming.style.transform = `translateX(calc(${dir} * (100% + 12px)))`;
              void incoming.offsetWidth;
              incoming.style.transition = '';
              incoming.style.transform = '';
            }
          }

          this.querySelectorAll('.dm-boxsel__card').forEach((card) => {
            card.classList.toggle('is-reco', card.dataset.box === box);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dm-faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dm-faq')) {
    customElements.define(
      'dm-faq',
      class extends HTMLElement {
        connectedCallback() {
          this.build();
          this.mo = new MutationObserver(() => this.build());
          this.mo.observe(this.querySelector('.dm-faq__panels'), { childList: true });
        }

        disconnectedCallback() {
          this.mo?.disconnect();
        }

        build() {
          const bar = this.querySelector('.dm-faq__tabs');
          const panels = [...this.querySelectorAll('.dm-faq__panel')];
          bar.innerHTML = '';
          if (panels.length < 2) {
            bar.hidden = true;
            panels.forEach((p) => (p.hidden = false));
            return;
          }
          bar.hidden = false;
          const current = Math.max(0, panels.findIndex((p) => !p.hidden && p.dataset.active === 'true'));
          panels.forEach((panel, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'dm-faq__tab';
            b.setAttribute('role', 'tab');
            b.textContent = panel.dataset.label || 'Onglet ' + (i + 1);
            b.addEventListener('click', () => this.show(i));
            bar.appendChild(b);
          });
          this.show(current);
        }

        show(index) {
          const tabs = [...this.querySelectorAll('.dm-faq__tab')];
          [...this.querySelectorAll('.dm-faq__panel')].forEach((p, i) => {
            p.hidden = i !== index;
            p.dataset.active = i === index;
            tabs[i]?.setAttribute('aria-selected', i === index);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dm-ig-posts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dm-ig-posts')) {
    customElements.define(
      'dm-ig-posts',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.dm-igp__track');
          this.dots = this.querySelector('.dm-igp__dots');
          if (!this.track || !this.dots) return;
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.dots.addEventListener('click', (e) => {
            const dot = e.target.closest('button');
            const item = this.track.querySelector('.dm-igp__item');
            if (!dot || !item) return;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            this.track.scrollTo({ left: Number(dot.dataset.i) * (item.offsetWidth + gap), behavior: 'smooth' });
          });
          this.ro = new ResizeObserver(() => this.build());
          this.ro.observe(this.track);
          this.build();
        }

        disconnectedCallback() {
          this.ro?.disconnect();
        }

        build() {
          const count = this.track.querySelectorAll('.dm-igp__item').length;
          const n = this.track.scrollWidth - this.track.clientWidth > 2 ? count : 0;
          if (this.dots.childElementCount !== n) {
            this.dots.innerHTML = '';
            for (let i = 0; i < n; i++) {
              const b = document.createElement('button');
              b.type = 'button';
              b.tabIndex = -1;
              b.dataset.i = i;
              this.dots.appendChild(b);
            }
          }
          this.update();
        }

        update() {
          const item = this.track.querySelector('.dm-igp__item');
          if (!item || !this.dots.childElementCount) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const max = this.track.scrollWidth - this.track.clientWidth;
          let i = Math.round(this.track.scrollLeft / (item.offsetWidth + gap));
          if (this.track.scrollLeft >= max - 2) i = this.dots.childElementCount - 1;
          [...this.dots.children].forEach((d, k) => d.classList.toggle('is-active', k === i));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dm-needs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dm-needs')) {
    customElements.define(
      'dm-needs',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.dm-nd__track');
          this.dots = this.querySelector('.dm-nd__dots');
          if (!this.track || !this.dots) return;
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.dots.addEventListener('click', (e) => {
            const dot = e.target.closest('button');
            const item = this.track.querySelector('.dm-nd__item');
            if (!dot || !item) return;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            this.track.scrollTo({ left: Number(dot.dataset.i) * (item.offsetWidth + gap), behavior: 'smooth' });
          });
          this.ro = new ResizeObserver(() => this.build());
          this.ro.observe(this.track);
          this.build();
        }

        disconnectedCallback() {
          this.ro?.disconnect();
        }

        build() {
          const count = this.track.querySelectorAll('.dm-nd__item').length;
          const n = this.track.scrollWidth - this.track.clientWidth > 2 ? count : 0;
          if (this.dots.childElementCount !== n) {
            this.dots.innerHTML = '';
            for (let i = 0; i < n; i++) {
              const b = document.createElement('button');
              b.type = 'button';
              b.tabIndex = -1;
              b.dataset.i = i;
              this.dots.appendChild(b);
            }
          }
          this.update();
        }

        update() {
          const item = this.track.querySelector('.dm-nd__item');
          if (!item || !this.dots.childElementCount) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const max = this.track.scrollWidth - this.track.clientWidth;
          let i = Math.round(this.track.scrollLeft / (item.offsetWidth + gap));
          if (this.track.scrollLeft >= max - 2) i = this.dots.childElementCount - 1;
          [...this.dots.children].forEach((d, k) => d.classList.toggle('is-active', k === i));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dm-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dm-reviews')) {
    customElements.define(
      'dm-reviews',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.dm-rv__track');
          this.dots = this.querySelector('.dm-rv__dots');
          if (!this.track || !this.dots) return;
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.dots.addEventListener('click', (e) => {
            const dot = e.target.closest('button');
            if (!dot) return;
            const item = this.track.querySelector('.dm-rv__item');
            if (!item) return;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            this.track.scrollTo({ left: Number(dot.dataset.i) * (item.offsetWidth + gap), behavior: 'smooth' });
          });
          this.ro = new ResizeObserver(() => this.build());
          this.ro.observe(this.track);
          this.build();
        }

        disconnectedCallback() {
          this.ro?.disconnect();
        }

        build() {
          const count = this.track.querySelectorAll('.dm-rv__item').length;
          const scrollable = this.track.scrollWidth - this.track.clientWidth > 2;
          const n = scrollable ? count : 0;
          if (this.dots.childElementCount !== n) {
            this.dots.innerHTML = '';
            for (let i = 0; i < n; i++) {
              const b = document.createElement('button');
              b.type = 'button';
              b.tabIndex = -1;
              b.dataset.i = i;
              this.dots.appendChild(b);
            }
          }
          this.update();
        }

        update() {
          const item = this.track.querySelector('.dm-rv__item');
          if (!item || !this.dots.childElementCount) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const max = this.track.scrollWidth - this.track.clientWidth;
          let i = Math.round(this.track.scrollLeft / (item.offsetWidth + gap));
          if (this.track.scrollLeft >= max - 2) i = this.dots.childElementCount - 1;
          [...this.dots.children].forEach((d, k) => d.classList.toggle('is-active', k === i));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
